export const captchaAppId = '199268779';



// WEBPACK FOOTER //
// ./src/config/index.js